import { adminHttpClient } from '../commons/adminHttpClient'

export enum FamilyStatus {
  Single = 1,
  SingleWithDependents = 2,
  Married = 3,
  MarriedWithDependents = 4,
}

export interface FamilyStatusValues {
  familyStatusId: number | null
}

const familyStatusApi = (familyStatus: FamilyStatusValues): Promise<any> => {
  return adminHttpClient.put('/EESignup/FamilyStatus', familyStatus)
}

export default familyStatusApi
